"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class Strong extends mark_1.Mark {
    constructor() {
        super('strong');
    }
}
exports.Strong = Strong;
//# sourceMappingURL=strong.js.map